import React from 'react';
import { Modal as ReactBootstrapModal, ModalBody } from 'react-bootstrap';

import styled from 'styled-components';
import PropTypes from 'prop-types';

const ModalStyled = styled(ReactBootstrapModal)`
  background-color: ${(props)=> props.theme.palette.common.background + '66'};
  .modal-content {
    color: ${(props) => props.theme.palette.card.text.primary};
    background-color: ${(props) => props.theme.palette.card.background.secondary};
    box-shadow: 0px 0px 20px ${(props) => props.theme.palette.card.boxShadow.primary};
    border-radius: .8rem;
    border: none;
    position: absolute;
    right: 10%;
    width: 80%;

    .modal-body {
      padding: ${(props) => (props.padding ? props.padding : '.5rem 2.5rem')};
      text-align: center;
      width: ${(props) => (props.width ? props.width : '100%')};
      margin: ${({modal})=> modal? 'auto ': '30px auto'};
    }
  }
`;

const Modal = ({ children, ...props }) => {
  return (
    <ModalStyled {...props}>
      <ModalBody>{children}</ModalBody>
    </ModalStyled>
  );
};

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element,
  ]),
};

export default Modal;
